import { axios } from '@ori/axios';
import { handleResponse, validateStatus } from '@ori/fetching';
import type { SpaConfigContext } from '@ori-appshell/config';

type GetUserData = Pick<SpaConfigContext, 'onlineBaseUrl'>;

export interface UserData {
  email: string | null;
  telephoneNumber: string | null;
}

export const getUserData = async ({ onlineBaseUrl }: GetUserData): Promise<UserData> => {
  const response = await axios.get<UserData>(
    new URL('/system/ajax/stockNotification/userData', onlineBaseUrl ?? window.location.origin).toString(),
    {
      validateStatus,
    },
  );

  return handleResponse(response, {
    onError: () => ({ email: null, telephoneNumber: null }),
    onSuccess: (res) => res.data,
  });
};
